import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiService from '@/services/ApiService'
import InlineSvgComponent from 'vue-inline-svg'
import VueMatomo from 'vue-matomo'
import { i18n } from '@/config/i18n'
import * as Sentry from '@sentry/vue'
import { migrateLegacyOAuthStorageEntries } from '@/services/AuthenticationRedirectContext'

const app = createApp(App)

if (process.env.VUE_APP_ENV !== 'dev') {
  app.use(VueMatomo, {
    host: 'https://matomo.devinci.me',
    siteId: 15,
    router: router
  })

  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  })
}

app.use(i18n)
app.use(store)
app.use(router)
app.component('inline-svg', InlineSvgComponent)
ApiService.init(app)

// Restaurer la langue depuis le localStorage
const savedLocale = localStorage.getItem('locale')
if (savedLocale && ['fr', 'en'].includes(savedLocale)) {
  i18n.global.locale.value = savedLocale as 'fr' | 'en'
}

// Gestionnaire d'erreurs global
app.config.errorHandler = (err, instance, info) => {
  console.error('Erreur globale capturée:', err)
  console.error('Info:', info)
  console.error('Instance:', instance)

  // Rediriger vers la page d'erreur avec le message
  router.push({
    name: 'error',
    query: {
      message: (err as Error).message || 'Une erreur inattendue s\'est produite',
      details: process.env.VUE_APP_ENV === 'dev' ? (err as Error).stack : undefined
    }
  })
}

// Restaurer la session utilisateur depuis le localStorage
store.dispatch('restoreSession')

// Adopter les emplacements de l'ancienne implémentation du contexte de redirection, avant que
// le routeur ne le lise : sans cette reprise, un utilisateur en cours de flux au moment du
// déploiement perdrait sa redirection.
migrateLegacyOAuthStorageEntries()

app.mount('#app')

const _paq = (window as any)._paq || []
_paq.push(['trackPageView'])
